	/**
	* Returns a formatted date string, considering null or empty values.
	* @param {?} value - Any nullable value.
	* @param {boolean} includeTime - TRUE if the time is included, FALSE otherwise.
	* @param {boolean} dashIfEmpty - TRUE if an empty time returns a dash, FALSE if an empty item remains blank.
	* @returns {string} A string formatted date, or a string based upon dashIfEmpty.
	*/
export function formatDate(value, includeTime = false, dashIfEmpty = true) {
	if ((value) && ((typeof (value) === "number") || ((value !== "null") && (value.trim().length)))) {
		let d = new Date(value);
		if (includeTime) {
			return d.toLocaleString('en-GB').replace(/\u200E/g, "");
		}
		else {
			return d.toLocaleDateString('en-GB').replace(/\u200E/g, "");
		}
	}
	return (dashIfEmpty) ? "-" : "";
}

/**
	* Converts a value into a file size string, based on Kb,Mb or Gb.
	* @param {number} value - The size of the file.
	* @returns {string} A file size in string format.
	*/
export function formatFileSize(value) {
	let size = value / 1024;
	if (size < 1024) {
		return Math.round(size) + "Kb";
	}
	size /= 1024;
	if (size < 1024) {
		return size.toFixed(1) + "Mb";
	}
	size /= 1024;
	return size.toFixed(1) + "Gb";
}